<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventory.operation.stock_in.stock_in') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('inventory.operation.stock_in.stock_in'),
            href: '/stock-ins'
          },
          { text: $t('inventory.operation.stock_in.create'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3">
                  {{ $t('inventory.operation.stock_in.po_number') }}
                  <i class="fas fa-spinner spin" v-if="po_fetch == true"></i>
                </label>
                <div class="col-md-8">
                  <select
                    v-model.number="model.po_id"
                    class="form-control"
                    @change="onPOChange"
                  >
                    <option value="">{{ $t('select') }}</option>
                    <option
                      v-for="(po, index) in POLists"
                      :key="index"
                      :value="po.po_id"
                    >
                      {{ po.po_number }}
                    </option>
                  </select>
                  <small>
                    <p>
                      <i>
                        {{
                          $t(
                            'inventory.operation.stock_in.it_is_optional_option'
                          )
                        }}
                      </i>
                    </p></small
                  >
                </div>
              </div>

              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3">
                  {{ $t('inventory.operation.stock_in.supplier/vendor') }}
                  <span class="text-danger">*</span>
                </label>
                <div class="col-md-8">
                  <select
                    v-model="model.supplier_id"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('supplier_id') }"
                    :disabled="!suppliers.length || model.po_id != ''"
                  >
                    <option value="">{{ $t('select') }}</option>
                    <option
                      v-for="(supplier, index) in suppliers"
                      :key="index"
                      :value="supplier.supplier_id"
                    >
                      {{ supplier.supplier_name_en }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('supplier_id')"
                  >
                    {{ errors.first('supplier_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3">
                  {{ $t('inventory.operation.stock_in.credit_day') }}
                </label>
                <div class="col-md-8">
                  <input
                    type="number"
                    v-model.number="model.term_days"
                    class="form-control-plaintext"
                    disabled
                  />
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3">
                  {{ $t('inventory.operation.stock_in.credit_amount') }}
                </label>
                <div class="col-md-8">
                  <input
                    type="number"
                    v-model.number="model.term_amount"
                    class="form-control-plaintext"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3"
                  >{{ $t('inventory.operation.stock_in.date') }}
                  <span class="text-danger">*</span></label
                >
                <div class="col-md-8">
                  <ts-date-picker-input
                    v-model="model.stock_in_date"
                  ></ts-date-picker-input>
                  <div class="validate" v-if="errors.has('stock_in_date')">
                    {{ errors.first('stock_in_date') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3">{{
                  $t('inventory.operation.stock_in.reference_invoice')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model.trim="model.invoice_no"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('invoice_no') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('invoice_no')">
                    {{ errors.first('invoice_no') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3">
                  {{ $t('inventory.operation.stock_in.warehouse') }}
                  <span class="text-danger">*</span>
                </label>
                <div class="col-md-8">
                  <select
                    v-model="model.location_id"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('location_id') }"
                    :disabled="!wareHouses.length"
                  >
                    <option value="">
                      {{ $t('select') }}
                    </option>
                    <option
                      v-for="(warehouse, index) in wareHouses"
                      :key="index"
                      :value="warehouse.location_id"
                    >
                      {{ warehouse.location_name }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('stock_in_date')"
                  >
                    {{ errors.first('stock_in_date') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3">{{
                  $t('stockin.fxRate')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="number"
                    v-model.number="model.fx_rate"
                    class="form-control-plaintext"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <panel title="Stock In Items">
                <div id="container-table">
                  <table class="table ui-table table-hover">
                    <thead>
                      <tr>
                        <th style="width: 14%">
                          {{ $t('inventory.operation.stock_in.barcode') }}
                        </th>
                        <th style="width: 23%">
                          {{ $t('inventory.operation.stock_in.product') }}
                        </th>
                        <!-- <th style="width: 11%">
                          {{ $t('inventory.operation.stock_in.expire_date') }}
                        </th> -->
                        <th style="width: 9%">
                          {{ $t('inventory.operation.stock_in.uom') }}
                        </th>
                        <th style="width: 9%">
                          {{ $t('inventory.operation.stock_in.cost') }}
                        </th>
                        <th class="text-center" style="width: 9%">
                          {{ $t('inventory.operation.stock_in.qty') }}
                        </th>
                        <th style="width: 9%">
                          {{ $t('inventory.operation.stock_in.dis') }}
                        </th>
                        <th style="width: 9%">
                          {{ $t('inventory.operation.stock_in.vat') }}
                        </th>
                        <th style="width: 10%">
                          {{ $t('inventory.operation.stock_in.amount') }}
                        </th>
                        <th style="width: 2%" class="text-center">
                          <a href="#" class="text-primary">
                            <i
                              class="fas fa-spinner spin"
                              v-if="ready_fetch"
                            ></i>
                            <i
                              class="fa fa-plus"
                              v-else
                              @click.prevent="addNewRow"
                            ></i>
                          </a>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in model.sub_item_list"
                        :key="index"
                      >
                        <td>
                          <select
                            class="form-control only-border-bottom"
                            v-model="item.barcode"
                            @change="barcodeChange(item)"
                          >
                            <option value="">
                              {{ $t('select') }}
                            </option>
                            <option
                              v-for="(product, index) in products"
                              :key="index"
                              :value="product.barcode"
                            >
                              {{ product.barcode }}
                            </option>
                          </select>
                        </td>
                        <td>
                          <select
                            class="form-control only-border-bottom"
                            :class="{
                              'is-invalid': errors.has(
                                'sub_item_list.' + index + '.product_id'
                              )
                            }"
                            v-model="item.product_id"
                            @change="productChange(item)"
                          >
                            <option value="">
                              {{ $t('select') }}
                            </option>
                            <option
                              v-for="(product, index) in products"
                              :key="index"
                              :value="product.product_id"
                            >
                              {{ product.product_name_en }}
                            </option>
                          </select>
                          <div
                            class="invalid-feedback"
                            v-if="
                              errors.has(
                                'sub_item_list.' + index + '.product_id'
                              )
                            "
                          >
                            {{
                              errors.first(
                                'sub_item_list.' + index + '.product_id'
                              )
                            }}
                          </div>
                        </td>
                        <!-- <td>
                          <ts-date-picker-input
                            v-model="item.expiry_date"
                          ></ts-date-picker-input>
                        </td> -->
                        <td>
                          <select
                            class="form-control only-border-bottom"
                            :class="{
                              'is-invalid': errors.has(
                                'sub_item_list.' + index + '.uom_id'
                              )
                            }"
                            v-model="item.uom_id"
                            @change="onUomChange(item)"
                          >
                            <option value="">
                              {{ $t('select') }}
                            </option>
                            <option
                              v-for="(uom, index) in uomGetter(item)"
                              :key="index"
                              :value="uom.uom_id"
                            >
                              {{ uom.uom_name_en }}
                            </option>
                          </select>
                          <div
                            class="invalid-feedback"
                            v-if="
                              errors.has('sub_item_list.' + index + '.uom_id')
                            "
                          >
                            {{
                              errors.first('sub_item_list.' + index + '.uom_id')
                            }}
                          </div>
                        </td>
                        <td>
                          <input
                            type="number"
                            v-model.number="item.cost"
                            step="any"
                            class="form-control only-border-bottom"
                            :class="{
                              'is-invalid': errors.has(
                                'sub_item_list.' + index + '.cost'
                              )
                            }"
                            disabled
                          />
                          <div
                            class="invalid-feedback"
                            v-if="
                              errors.has('sub_item_list.' + index + '.cost')
                            "
                          >
                            {{
                              errors.first('sub_item_list.' + index + '.cost')
                            }}
                          </div>
                        </td>
                        <td>
                          <input
                            type="number"
                            v-model.number="item.qty"
                            step="any"
                            class="form-control only-border-bottom"
                            :class="{
                              'is-invalid': errors.has(
                                'sub_item_list.' + index + '.qty'
                              )
                            }"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="errors.has('sub_item_list.' + index + '.qty')"
                          >
                            {{
                              errors.first('sub_item_list.' + index + '.qty')
                            }}
                          </div>
                        </td>
                        <td>
                          <input
                            type="number"
                            v-model="item.discount_rate"
                            step="any"
                            class="form-control only-border-bottom"
                            :class="{
                              'is-invalid': errors.has(
                                'sub_item_list.' + index + '.discount_rate'
                              )
                            }"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="
                              errors.has(
                                'sub_item_list.' + index + '.discount_rate'
                              )
                            "
                          >
                            {{
                              errors.first(
                                'sub_item_list.' + index + '.discount_rate'
                              )
                            }}
                          </div>
                        </td>
                        <td>
                          <input
                            type="number"
                            v-model.number="item.vat_rate"
                            step="any"
                            class="form-control only-border-bottom"
                            :class="{
                              'is-invalid': errors.has(
                                'sub_item_list.' + index + '.vat_rate'
                              )
                            }"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="
                              errors.has('sub_item_list.' + index + '.vat_rate')
                            "
                          >
                            {{
                              errors.first(
                                'sub_item_list.' + index + '.vat_rate'
                              )
                            }}
                          </div>
                        </td>
                        <td>
                          <input
                            disabled
                            type="number"
                            step="any"
                            class="form-control only-border-bottom"
                            :value="totalAmount(item)"
                          />
                        </td>
                        <td class="text-center">
                          <a
                            href="#"
                            class="text-danger"
                            @click.prevent="removeRow(item)"
                          >
                            <i class="fa fa-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </panel>
              <table
                style="width: 100%"
                class="mt-2"
                id="amountValue"
                v-if="model.sub_item_list.length"
              >
                <tr>
                  <td style="width: 80%" class="text-right">
                    <label class="col-form-label"
                      >{{ $t('inventory.operation.stock_in.sub_total') }} :
                    </label>
                  </td>
                  <td class="pl-2 pr-5" style="width: 18%">
                    <input
                      disabled
                      type="number"
                      v-model.number="model.sub_total"
                      step="any"
                      class="form-control only-border-bottom"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 80%" class="text-right">
                    <label class="col-form-label"
                      >{{ $t('inventory.operation.stock_in.vat_rate')
                      }}<span class="text-danger">*</span> :
                    </label>
                  </td>
                  <td class="pl-2 pr-5" style="width: 18%">
                    <input
                      type="number"
                      v-model.number="model.vat_rate"
                      step="any"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('vat_rate') }"
                    />
                    <div class="invalid-feedback" v-if="errors.has('vat_rate')">
                      {{ errors.first('vat_rate') }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 80%" class="text-right">
                    <label class="col-form-label"
                      >{{ $t('inventory.operation.stock_in.grand_total') }} :
                    </label>
                  </td>
                  <td class="pl-2 pr-5" style="width: 18%">
                    <input
                      disabled
                      type="number"
                      v-model.number="model.grand_total"
                      step="any"
                      class="form-control only-border-bottom"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <ts-button
                class="btn-primary mr-2"
                @click.prevent="store"
                :waiting="saving"
                v-if="model.sub_item_list.length"
              >
                {{ $t('save') }}
              </ts-button>
              <ts-button
                class="btn-primary mr-2"
                @click.prevent="saveNew"
                :waiting="saving_new"
                v-if="model.sub_item_list.length"
              >
                {{ $t('save_add_new') }}
              </ts-button>
              <ts-button
                class="btn-default"
                @click="$router.push({ name: 'stock-in' })"
              >
                {{ $t('cancel') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'stock-in-create',
  data () {
    return {
      model: {
        invoice_no: '',
        stock_in_date: moment().format('DD-MM-YYYY'),
        po_id: '',
        supplier_id: '',
        term_days: 0,
        term_amount: 0,
        fx_rate: '',
        sub_total: 0,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        location_id: '',
        sub_item_list: []
      },
      newRow: {
        stock_in_detail_id: 0,
        barcode: '',
        product_id: '',
        expiry_date: '',
        uom_id: '',
        cost: 0,
        qty: 1,
        discount_rate: 0,
        vat_rate: 0
      },
      errors: new Errors(),
      ready_fetch: false,
      po_fetch: false,
      saving: false,
      saving_new: false
    }
  },
  computed: {
    ...mapState('stockIn', [
      'POLists',
      'wareHouses',
      'suppliers',
      'exchangeRate',
      'products'
    ]),
    ...mapGetters('stockIn', [
      'uomGetter',
      'productPrice',
      'totalAmount',
      'subTotal'
    ])
  },
  created () {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    fetchResourceBeforeCreate () {
      this.ready_fetch = true
      this.$store
        .dispatch('stockIn/dataBeforeCreate')
        .then(response => {
          this.model.fx_rate = _.ceil(this.exchangeRate, 2)
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    addNewRow () {
      this.model.sub_item_list.push(_.clone(this.newRow))
    },
    removeRow (item) {
      this.model.sub_item_list.splice(this.model.sub_item_list.indexOf(item), 1)
    },
    barcodeChange (item) {
      if (!item.barcode) {
        item.product_id = ''
        item.uom_id = ''
        return
      }
      let result = this.products.filter(p => p.barcode == item.barcode)
      item.product_id = result[0].product_id
      item.uom_id = ''
      this.onUomChange(item)
    },
    productChange (item) {
      if (!item.product_id) {
        item.product_id = ''
        item.uom_id = ''
        return
      } else {
        let result = this.products.filter(p => p.product_id == item.product_id)
        item.barcode = result[0].barcode
        item.uom_id = ''
        this.onUomChange(item)
      }
    },
    onUomChange (item) {
      try {
        let productPrice = this.productPrice(item.product_id, item.uom_id)
        if (productPrice) {
          item.cost = _.ceil(productPrice.cost, 2)
        } else {
          item.cost = 0
        }
      } catch (e) {
        item.cost = ''
      }
    },
    async onPOChange () {
      if (!this.model.po_id) {
        this.clearInput()
        return
      }
      if (
        await this.$confirmModal.danger('Are you sure to load PO resource ?')
      ) {
        this.po_fetch = true
        let response = await this.$store.dispatch(
          'stockIn/getPOResource',
          this.model.po_id
        )
        this.model.supplier_id = response.data.supplier_id
        this.model.sub_item_list = []
        response.data.details.forEach(po => {
          this.model.sub_item_list.push(po)
          this.onUomChange(po)
        })
        this.po_fetch = false
      } else {
        this.model.po_id = ''
      }
    },
    grandTotal () {
      let vat_amount = (this.model.sub_total * this.model.vat_rate) / 100
      this.model.vat_amount = vat_amount
      this.model.grand_total = this.model.sub_total + vat_amount
    },
    store () {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('stockIn/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-in' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    saveNew () {
      this.errors = new Errors()
      this.saving_new = true
      this.$store
        .dispatch('stockIn/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.saving_new = false
        })
        .catch(error => {
          this.saving_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearInput () {
      this.model = {
        invoice_no: '',
        stock_in_date: moment().format('DD-MM-YYYY'),
        po_id: '',
        fx_rate: _.ceil(this.exchangeRate, 2),
        supplier_id: '',
        term_days: 0,
        term_amount: 0,
        sub_total: 0,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        location_id: '',
        sub_item_list: []
      }
    }
  },
  watch: {
    'model.sub_item_list': {
      handler () {
        let result = this.subTotal(this.model.sub_item_list)
        this.model.sub_total = result
        this.grandTotal()
        if (!this.model.sub_item_list.length > 0) {
          this.model.po_id = ''
        }
      },
      deep: true
    },
    'model.vat_rate': function (value) {
      this.grandTotal()
    },
    'model.supplier_id': function (value) {
      if (value) {
        let result = this.suppliers.filter(s => s.supplier_id == value)
        this.model.term_days = parseInt(result[0].credit_day)
        this.model.term_amount = parseFloat(result[0].credit_amount)
      } else {
        this.model.term_days = 0
        this.model.term_amount = 0
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stockIn/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
#container-table {
  max-height: 40vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
table td {
  vertical-align: middle;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
#amountValue tr > td {
  padding: 5px;
}
</style>
